import variables from '../../variables.module.scss';

const MuiButton = (breakpoints) => ({
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: '3px',
      fontSize: 16,
      lineHeight: '15px',
      color: variables.buttonText,
      minHeight: '38px',
      cursor: 'pointer',
      boxShadow: 'none',
      '&.primary-btn': {
        backgroundColor: variables.primary,
        [breakpoints.down('sm')]: {
          width: '100%',
        },
        [breakpoints.down('md')]: {
          width: 343,
          itemAlign: 'center',
        },
        '&:hover': {
          backgroundColor: variables.primary,
        },
        '&:disabled': {
          opacity: '0.3',
        },
        '&.start-here-calculate': {
          lineHeight: 'inherit',
          minHeight: '40px',
          fontFamily: variables.fontRegular,
          backgroundColor: variables.startHereCalculateBtnColor,
          letterSpacing: '-0.55px',
          fontSize: 18,
          width: '100%',
        },
        '&.download-brochure': {
          minHeight: '40px',
          fontFamily: variables.fontRegular,
          backgroundColor: variables.startHereCalculateBtnColor,
          letterSpacing: '-0.55px',
          fontSize: 18,
          width: '200px',
          [breakpoints.down('sm')]: {
            width: '100%',
          },
        },
      },
      '&.continue-btn': {
        [breakpoints.down('sm')]: {
          margin: 'auto',
        },
      },
      '&.expand-header-button': {
        color: variables.white,
        minWidth: '35px',
        minHeight: '35px',
        border: `1px solid ${variables.appBarMenuTitleColor}`,
        borderRadius: 0,
        padding: '0.25em',
      },
      '&.expand-header-button, &:focus': {
        outline: 0,
      },
      '&.ghost-btn': {
        fontFamily: variables.fontRegular,
        color: variables.startHereCalculateBtnColor,
        background: 'none',
        textDecoration: 'underline',
        '&:hover': {
          fontFamily: variables.fontBold,
          textDecorationThickness: 2,
        },
      },
      '&.start-here-scroll-down-button': {
        '&div': {
          cursor: 'pointer',
        },
        cursor: 'pointer',
        borderRadius: 40,
        backgroundColor: variables.startHereScrollDownButton,
      },
      '&.homepage-button': {
        fontSize: '18px',
        fontFamily: variables.fontRegular,
        borderRadius: '3px',
      },
      '&.learn-more-button': {
        borderRadius: '3px',
        border: `1px solid ${variables.textLearnMoreColor}`,
        height: '32px',
        margin: 'auto',
        color: variables.textLearnMoreColor,
        fontFamily: variables.fontRegular,
        fontSize: '18px',
        letterSpacing: '-0.55px',
        textAlign: 'center',
        paddingLeft: '16px',
        paddingRight: '16px',
        [breakpoints.down('customtablet')]: {
          width: 100,
        },
      },
    },
    label: {
      color: variables.buttonLabelColor,
      fontFamily: variables.buttonLabelFont,
    },
  },
});

export default MuiButton;
